/**
 * Helper pour gérer les mises à jour de crédits
 * Centralise l'invalidation des queries React Query liées aux crédits
 */

/**
 * Invalide toutes les queries liées aux crédits pour forcer un refresh
 * @param {QueryClient} queryClient - Instance de React Query Client
 */
export const refreshCreditsDisplay = (queryClient) => {
  // Invalider la query du solde de crédits (utilisée par la topbar)
  queryClient.invalidateQueries({ queryKey: ['credits'] })
  
  // Invalider l'historique des transactions
  queryClient.invalidateQueries({ queryKey: ['creditHistory'] })
}

/**
 * Met à jour le solde de crédits dans le store Zustand et rafraîchit l'affichage
 * @param {number} newBalance - Nouveau solde de crédits
 * @param {Function} updateUser - Fonction du store pour mettre à jour l'utilisateur
 * @param {Object} user - Objet utilisateur actuel
 * @param {QueryClient} queryClient - Instance de React Query Client
 */
export const updateCreditsBalance = (newBalance, updateUser, user, queryClient) => {
  // Mettre à jour le store Zustand
  updateUser({ ...(user || {}), credits: newBalance })
  
  // Invalider les queries pour forcer un refresh
  refreshCreditsDisplay(queryClient)
}
